import { useEffect, useState } from 'react'
import memoize from 'fast-memoize'

function createHiddenInputForRingpool(key, value) {
	const hasExistingInput = document.getElementsByName(key).length

	if (!hasExistingInput && key && value) {
		const input = document.createElement('input')
		input.setAttribute('type', 'hidden')
		input.setAttribute('name', key)
		input.setAttribute('value', value)

		//append to form element that you want
		document.body.appendChild(input)
	}
}

function loadRingpoolScript(callback) {
	const existingScript = document.getElementById('ringpoolScript')
	if (!existingScript) {
		const script = document.createElement('script')
		script.src = `${process.env.GATSBY_CF_RINGCENTER_BASE_URL}/Resources/JS/autoringpool-latest-v4.js`
		script.id = 'ringpoolScript'
		document.body.appendChild(script)
		script.onload = () => {
			if (callback) {
				callback()
			}
		}
	}
	if (existingScript && callback) {
		callback()
	}
}

const getQtOfferData = memoize(async (affId, offerId) => {
	try {
		const url = new URL(`${process.env.GATSBY_RFQ_API_BASE_URL}/v2/qt/offer`)
		const params = { affId, offerId }
		url.search = new URLSearchParams(params).toString()
		const response = await fetch(url)
		return await response.json()
	} catch (error) {
		throw new Error(error)
	}
})

export function useQt({ affId, offerId }) {
	const [offer, setOffer] = useState({})

	useEffect(() => {
		const getOfferData = async () => {
			try {
				const data = await getQtOfferData(affId, offerId)
				setOffer(data)
				if (data.ringpoolId && data.ringpoolDefaultPhone) {
					createHiddenInputForRingpool('cf_attr1', affId)
					createHiddenInputForRingpool('cf_attr2', document.location.href)
					setTimeout(() => {
						loadRingpoolScript()
					}, 500)
				}
			} catch (error) {
				console.log(error)
				setOffer({})
			}
		}
		if (affId && offerId) {
			getOfferData()
		}
	}, [affId, offerId])

	return offer
}
